function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7a9ac;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Instagram_icon");

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 25.3,
  cy: 25.19,
  r: 5.94
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M379,145.41a5.88,5.88,0,0,0-3.38-3.38,9.78,9.78,0,0,0-3.31-.61c-1.87-.08-2.44-0.1-7.2-0.1s-5.32,0-7.2.1a9.83,9.83,0,0,0-3.31.61,5.54,5.54,0,0,0-2,1.33,5.42,5.42,0,0,0-1.34,2,9.78,9.78,0,0,0-.61,3.31c-0.08,1.87-.1,2.45-0.1,7.2s0,5.32.1,7.2a9.82,9.82,0,0,0,.61,3.31,5.55,5.55,0,0,0,1.33,2,5.49,5.49,0,0,0,2,1.33,9.78,9.78,0,0,0,3.31.61c1.87,0.08,2.45.1,7.2,0.1s5.32,0,7.2-.1a9.82,9.82,0,0,0,3.31-.61,5.92,5.92,0,0,0,3.39-3.39,9.78,9.78,0,0,0,.61-3.31c0.08-1.88.1-2.44,0.1-7.2s0-5.32-.1-7.2A9.82,9.82,0,0,0,379,145.41Zm-13.91,19.66a9.16,9.16,0,1,1,9.16-9.16A9.16,9.16,0,0,1,365.09,165.07Zm9.52-16.55a2.14,2.14,0,1,1,2.14-2.14A2.14,2.14,0,0,1,374.62,148.52Z",
  transform: "translate(-339.8 -130.72)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M391.36,135.75a5,5,0,0,0-5-5h-41.5a5,5,0,0,0-5,5v41.5a5,5,0,0,0,5,5h41.5a5,5,0,0,0,5-5v-41.5Zm-8.54,27.51a13.07,13.07,0,0,1-.83,4.33,9.12,9.12,0,0,1-5.22,5.22,13,13,0,0,1-4.33.83c-1.9.08-2.51,0.1-7.35,0.1s-5.45,0-7.35-.1a13.07,13.07,0,0,1-4.33-.83,9.13,9.13,0,0,1-5.22-5.22,13,13,0,0,1-.83-4.33c-0.08-1.9-.1-2.51-0.1-7.35s0-5.45.11-7.36a13.07,13.07,0,0,1,.83-4.33,9.14,9.14,0,0,1,5.22-5.22,13,13,0,0,1,4.33-.83c1.9-.08,2.51-0.1,7.35-0.1s5.45,0,7.36.11a13.07,13.07,0,0,1,4.33.83,9.14,9.14,0,0,1,5.22,5.22,13,13,0,0,1,.83,4.33c0.08,1.9.09,2.51,0.09,7.35S382.9,161.36,382.81,163.26Z",
  transform: "translate(-339.8 -130.72)"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 51.56 51.56",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.130a5d03.svg";
export { ForwardRef as ReactComponent };